
import Vue from 'vue';
import { api, ApiKeySummary } from '@/services/api';
import { formatDate } from '@/services/date';

export default Vue.extend({
    data() {
        return {
            keys: [] as ApiKeySummary[],
            newName: "MCP analysis",
            createdKey: null as ApiKeySummary | null,
            isCreating: false
        }
    },
    async mounted() {
        await this.refresh();
    },
    methods: {
        async refresh() {
            this.keys = await api.listApiKeys();
        },
        async createKey() {
            if (this.isCreating) {
                return;
            }

            this.isCreating = true;
            try {
                const key = await api.createApiKey(this.newName);
                if (key) {
                    this.createdKey = key;
                    this.newName = "";
                    await this.refresh();
                }
            } finally {
                this.isCreating = false;
            }
        },
        async revokeKey(id: number) {
            await api.revokeApiKey(id);
            if (this.createdKey && this.createdKey.id === id) {
                this.createdKey = null;
            }
            await this.refresh();
        },
        date(value: string): string {
            return formatDate(new Date(value));
        }
    }
})
